import {Link} from 'react-router-dom';
import Header from  '././sub-components/Header';
import '../../../src/styles/profile.css';
import { db } from './firebase/firebase';
import {useState,useEffect} from 'react';
import { doc, getDoc} from "firebase/firestore";
import { de_encrypt } from '../../encryption';
import BaseNav from './sub-components/BaseNav';
const Profile=()=>{
    const [info,setInfo]=useState(null);
    const user_key = de_encrypt(localStorage.getItem('user-key'));
    useEffect(
        ()=>{
              if(info==null){
                  ( async ()=>{
                      const docRef = doc(db, "user", user_key);
                      const docSnap = await getDoc(docRef);
                       setInfo(docSnap.data())
                  })();
                }
        },[info])
          
          

    if(info){
        return (
            <div className="dashboard profile-container utility">
                 <Header />  
                 <BaseNav active={"Profile"} />
     
               
              
                 <div className="profile">
                     
                         
                     
                    <div className="info">
                         <h3>Personal Information</h3>
                         <p><strong>Name</strong> {info.name}</p>
                         <p><strong>Email</strong> {info.email}</p>
                    </div> 
                    <div className="info">
                         <h3>Package Information</h3>
                         <p><strong>Type</strong> {info.package_type}</p>
                         <p><strong>Mine Earning</strong> {info.mine_earning}</p>
                         <p><strong>Mine Duration</strong> {info.mine_duration == 1 ? "1 hour" : "24 hours"}</p>
     
                    </div>  
                    <div className="info">
                         <h3>Account Information</h3>
                         <p><strong>Account Number</strong> {info.acct_num == undefined ? "Not Set" : info.acct_num}</p>
                         <p><strong>Account Name</strong> {info.acct_name == undefined ? "Not Set" : info.acct_name}</p>
                         <p><strong>Bank name</strong> {info.bank_name == undefined ? "Not Set" : info.bank_name}</p>
                    </div> 
                    <Link to="/dashboard/account?status=edit" style={{color:"#9900EF"}}>Click here to edit your account details</Link>
                    
                 </div> 
                
            </div>
                 
         )
    }else{
        return (
            <div className="loader-container">
                <div className="loader-header bg-w">
                    <div className="container">
                        <div className="loader-header-top loader-element"></div>
                        <div className="loader-header-bottom loader-element"></div>
                    </div>
                </div>
                <div className="loader-main bg-ws">
                   <div className="loader-profile loader-element bg-w">
                      <div className="loader-profile-info">
                         <div className="profile-info-header loader-element-lead"></div> 
                         <div className="profile-info-pg loader-element"></div>
                         <div className="profile-info-pg loader-element"></div>
                      </div>
                      <div className="loader-profile-info">
                         <div className="profile-info-header loader-element-lead"></div> 
                         <div className="profile-info-pg loader-element"></div>
                         <div className="profile-info-pg loader-element"></div>
                         <div className="profile-info-pg loader-element"></div>
                      </div>
                      <div className="loader-profile-info">
                         <div className="profile-info-header loader-element-lead"></div> 
                         <div className="profile-info-pg loader-element"></div>
                         <div className="profile-info-pg loader-element"></div>
                         <div className="profile-info-pg loader-element"></div>
                      </div>
                     
                   </div>
                </div>
            </div>

        );
    }
   
}

export default Profile
